// The /pure entrypoint defers injecting the Stripe.js <script> (and its
// metrics iframe) until loadStripe() is actually called — the default
// entrypoint injects it as an import side effect on EVERY page that pulls
// this chunk, which broke the e2e suite's "no stray iframe" guard app-wide.
import { loadStripe } from "@stripe/stripe-js/pure"

// Stripe.js, loaded once and shared. The publishable key rides in on a
// <meta name="stripe-public-key"> tag rendered by the inertia layout (same
// pattern as the legacy Bootstrap checkout). Returns a promise that resolves to
// null when no key is present, so callers can degrade instead of throwing.
let stripePromise

export function getStripe() {
  if (!stripePromise) {
    const key =
      typeof document !== "undefined"
        ? document.querySelector('meta[name="stripe-public-key"]')?.getAttribute("content")
        : null

    stripePromise = key ? loadStripe(key) : Promise.resolve(null)
  }

  return stripePromise
}
